import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventsService, VariablesService } from '../../shared/services';
import { ContactDialogComponent } from '../contact-dialog/components/contact-dialog/contact-dialog.component';

@Component({
  selector: 'app-contact-beneficiary',
  templateUrl: './contact-beneficiary.component.html',
  styleUrls: ['./contact-beneficiary.component.scss']
})
export class ContactBeneficiaryComponent implements OnInit {

  @Input() fundraiser;

  constructor(
    private dialog: MatDialog,
    public vars: VariablesService,
    private events: EventsService
  ) { }

  ngOnInit(): void {
  }

  openDialog() {
    this.events.sendSystemEvent({
      eventName: 'contact_beneficiary',
      event_type: 'campaign',
      page_name: this.vars.pageName,
      event_type_id: this.vars.fundraiser.id,
    }).subscribe(_ => _);
    this.dialog.open(ContactDialogComponent, {
      data: {
        title: this.fundraiser?.beneficiaryname?.info_1,
        id: this.fundraiser.id,
        contact: this.fundraiser.non_medical ? 'ngo' : ''
      },
      width: '100vw',
      maxWidth: '590px',
      maxHeight: '98vh',
      panelClass: ['round-dialog', 'contact-modal']
    });
  }

}
